export enum DateModifiers {
    Days = 'Days',
    Hours = 'Hours',
    Minutes = 'Minutes',
}

export function convertIsoDateToTimestamp(isoDate: string): number {
    const date = new Date(isoDate);
    return date.getTime();
}

export function convertIsoDateToDate(isoDate: string): Date {
    return new Date(isoDate);
}

export function convertToIsoDateTime(date: Date): string {
    // Returns: `YYYY-MM-DD[T]hh:mm:ss.[000]Z`
    return date.toISOString();
}

export function getCurrentDate(): Date {
    return new Date();
}

export function getCurrentIsoDateTime(): string {
    const now = getCurrentDate();
    return convertToIsoDateTime(now);
}

function modifyDate(date: Date, duration: number, modifier: DateModifiers): Date {
    const dateCopy = new Date(date);

    switch (modifier) {
        case DateModifiers.Days:
            dateCopy.setHours(dateCopy.getHours() + 24 * duration);
            break;
        case DateModifiers.Hours:
            dateCopy.setHours(dateCopy.getHours() + duration);
            break;
        case DateModifiers.Minutes:
            dateCopy.setMinutes(dateCopy.getMinutes() + duration);
            break;
    }

    return dateCopy;
}

export function subtractFromDate(date: Date, duration: number, modifier: DateModifiers): Date {
    return modifyDate(date, duration * -1, modifier);
}
